import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#111111",
    },
  },

  components: {
    MuiTextField: {
      defaultProps: {
        size: "small",
      },
    },

    MuiSelect: {
      defaultProps: {
        size: "small",
      },
    },

    MuiOutlinedInput: {
      defaultProps: {
        size: "small",
      },
    },

    MuiInputBase: {
      defaultProps: {
        size: "small",
      },
    },

    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 12,
          fontWeight: 700,
        },
      },
    },
  },
});

export default theme;